__turbopack_context__.v({
  "alsoList": "I9xtAG_alsoList",
  "alsoRow": "I9xtAG_alsoRow",
  "alsoSummary": "I9xtAG_alsoSummary",
  "alsoTitle": "I9xtAG_alsoTitle",
  "alsoTitleBtn": "I9xtAG_alsoTitleBtn",
  "badge": "I9xtAG_badge",
  "badgeIcon": "I9xtAG_badgeIcon",
  "block": "I9xtAG_block",
  "eyebrow": "I9xtAG_eyebrow",
  "lead": "I9xtAG_lead",
  "leadBody": "I9xtAG_leadBody",
  "leadOnly": "I9xtAG_leadOnly",
  "leadSummary": "I9xtAG_leadSummary",
  "leadTitle": "I9xtAG_leadTitle",
  "window": "I9xtAG_window",
});
